<template>
    <a
        v-if="hasValue"
        href="#"
        class="fs-16 px-1 align-middle d-inline-block lh-1"
        :class="copied ? 'ri-check-line text-success' : 'ri-file-copy-line text-muted'"
        :title="copied ? 'Copié' : title"
        :aria-label="title"
        @click.prevent="copy"
    ></a>
</template>

<script setup>
import { computed, onBeforeUnmount, ref } from 'vue'

const props = defineProps({
    value: { type: [String, Number], default: null },
    label: { type: String, default: '' },
})

const copied = ref(false)
let resetTimer = null

const text = computed(() => (props.value === null || props.value === undefined ? '' : String(props.value).trim()))

// Un champ vide ou réduit au placeholder « -- » n'a rien à copier : on masque le bouton.
const hasValue = computed(() => text.value !== '' && text.value !== '--')

const title = computed(() => (props.label ? `Copier ${props.label}` : 'Copier'))

async function copy() {
    if (!hasValue.value) return

    try {
        await navigator.clipboard.writeText(text.value)
    } catch {
        // navigator.clipboard exige un contexte sécurisé : repli sur une sélection temporaire.
        const area = document.createElement('textarea')
        area.value = text.value
        area.setAttribute('readonly', '')
        area.style.position = 'fixed'
        area.style.opacity = '0'
        document.body.appendChild(area)
        area.select()
        document.execCommand('copy')
        document.body.removeChild(area)
    }

    // Retour visuel local plutôt qu'un toast : le bouton sert à enchaîner plusieurs
    // copies, une notification à chaque clic deviendrait vite envahissante.
    copied.value = true
    clearTimeout(resetTimer)
    resetTimer = setTimeout(() => {
        copied.value = false
    }, 1500)
}

onBeforeUnmount(() => clearTimeout(resetTimer))
</script>
